import { faEye, faEyeSlash } from "@fortawesome/pro-solid-svg-icons";
import { Box, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

import { DisabledArea, Icon, Typography } from "../../components/ui-v2";

const Container = styled(Stack)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  padding: theme.spacing(3),
  paddingTop: 0,
}));

const HeaderContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
}));

const IconContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  cursor: "pointer",
  color: theme.palette.secondary[3],
  "&:hover": {
    color: theme.palette.secondary[2],
  },
}));

interface SkeletonControlsProps {
  disabled: boolean;
  showSkeleton: boolean;
  onToggleSkeleton: () => void;
}

export const SkeletonControls = (props: SkeletonControlsProps) => {
  const { disabled, showSkeleton, onToggleSkeleton } = props;

  return (
    <DisabledArea disabled={disabled} title="No rigging found for model">
      <Container gap={2}>
        <HeaderContainer>
          <Typography color="secondary.2" variant="regular">
            Skeleton
          </Typography>
        </HeaderContainer>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography color="secondary.2" variant="small">
            Show Skeleton
          </Typography>
          <IconContainer onClick={onToggleSkeleton}>
            {showSkeleton ? (
              <Icon size="medium" icon={faEye} />
            ) : (
              <Icon size="medium" icon={faEyeSlash} />
            )}
          </IconContainer>
        </Box>
      </Container>
    </DisabledArea>
  );
};
